const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/android-beta.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/lib/i18n";
export const Route = createFileRoute("/{-$locale}/android-beta")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  head: () => ({
    meta: [{
      title: i18n.t("misc.androidBeta.meta.title")
    }, {
      name: "description",
      content: i18n.t("misc.androidBeta.meta.description")
    }]
  })
});